// CouponDetails.jsx
import React from "react";
import "./CouponDetails.css";
import Sidebar from "../Navigation/Sidebar/Sidebar";
import Couponimage from '../../assests/coupon_image.png';
import leftArrow from "../../assests/leftArrow.svg";
import Details from "../../assests/delivery-detail.png";
import Calander from '../../assests/calander.svg';
import dateTime from '../../assests/watch.svg';
import CouponMiniIcon from '../../assests/couponminiicon.png';
import { useNavigate } from "react-router-dom";

const CouponDetails = ({ coupon }) => {
  const navigate = useNavigate();
  
  const arrowClick = () => navigate("/home/coupon/list");

  const utcToIST = (utcDateStr) => {
    const date = new Date(utcDateStr);
    const options = {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    };

    const istString = date.toLocaleString('en-GB', options); 
    const [datePart, timePart] = istString.split(', ');

    return {
      date: datePart,
      time: timePart,
    };
  };

  const start = coupon?.createdAt ? utcToIST(coupon.createdAt) : null;
  const end = coupon?.expiryDate ? utcToIST(coupon.expiryDate) : null;

  return (
    <div className="coupon-details-page-wrapper">
      <Sidebar />
      <div className="coupon-details-main-container">
        {/* Header Section */}
        <div className="coupon-details-header">
          <button onClick={arrowClick} className="coupon-details-back-btn">
            <img src={leftArrow} alt="Back" className="coupon-details-back-icon" />
          </button>
          <h1 className="coupon-details-title">{coupon?.name}</h1>
        </div>

        {/* Two Column Layout */}
        <div className="coupon-details-two-columns">
          
          {/* Left Main Section */}
          <div className="coupon-details-left-section">
            <div className="coupon-details-card">
              <div className="coupon-details-card-header">
                <img src={CouponMiniIcon} className="coupon-details-card-icon" alt="icon" />
                <p className="coupon-details-card-title">Coupons Details</p>
              </div>

              <div className="coupon-details-content-wrapper">
                <div className="coupon-details-image-section">
                  <img src={Couponimage} alt="Coupon" className="coupon-details-image" />
                  <div className="coupon-details-info-section">
                    <div className="coupon-details-info-grid">
                      <div className="coupon-details-info-item">
                        <span className="coupon-details-info-label">Coupon ID:</span>
                        <span className="coupon-details-info-value">{coupon?.id}</span>
                      </div>
                      <div className="coupon-details-info-item">
                        <span className="coupon-details-info-label">Coupon Name:</span>
                        <span className="coupon-details-info-value">{coupon?.name}</span>
                      </div>
                      <div className="coupon-details-info-item">
                        <span className="coupon-details-info-label">Coupon Description:</span>
                        <span className="coupon-details-info-value">{coupon?.couponDescription}</span>
                      </div>
                      <div className="coupon-details-info-item">
                        <span className="coupon-details-info-label">Coupon Type:</span>
                        <span className="coupon-details-info-value">{coupon?.type}</span>
                      </div>
                      <div className="coupon-details-info-item">
                        <span className="coupon-details-info-label">Coupon Limit:</span>
                        <span className="coupon-details-info-value">{coupon?.couponLimit}</span>
                      </div>
                      <div className="coupon-details-info-item">
                        <span className="coupon-details-info-label">Coupon Device Usage:</span>
                        <span className="coupon-details-info-value">{coupon?.usagePerDevice}</span>
                      </div>
                    </div>
                    <div className="coupon-details-status-wrapper">
                      <span className="coupon-details-status-badge coupon-details-status-published">Published</span>
                    </div>
                  </div>
                </div>

                {/* Date Time Section */}
                <div className="coupon-details-datetime-section">
                  <div className="coupon-details-datetime-card">
                    <div className="coupon-details-datetime-row">
                      {/* Start Date */}
                      <div className="coupon-details-datetime-group">
                        <div className="coupon-details-datetime-item">
                          <img src={Calander} alt="calendar" className="coupon-details-datetime-icon" />
                          <div>
                            <span className="coupon-details-datetime-label">Start Date</span>
                            <span className="coupon-details-datetime-value">{start?.date}</span>
                          </div>
                        </div>
                        <div className="coupon-details-datetime-item">
                          <img src={dateTime} alt="time" className="coupon-details-datetime-icon" />
                          <div>
                            <span className="coupon-details-datetime-label">Start Time</span>
                            <span className="coupon-details-datetime-value">{start?.time}</span>
                          </div>
                        </div>
                      </div>

                      {/* End Date */}
                      <div className="coupon-details-datetime-group">
                        <div className="coupon-details-datetime-item">
                          <img src={Calander} alt="calendar" className="coupon-details-datetime-icon" />
                          <div>
                            <span className="coupon-details-datetime-label">End Date</span>
                            <span className="coupon-details-datetime-value">{end?.date}</span>
                          </div>
                        </div>
                        <div className="coupon-details-datetime-item">
                          <img src={dateTime} alt="time" className="coupon-details-datetime-icon" />
                          <div>
                            <span className="coupon-details-datetime-label">End Time</span>
                            <span className="coupon-details-datetime-value">{end?.time}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Amount Section */}
          <div className="coupon-details-right-section">
            <div className="coupon-details-amount-card">
              <h3 className="coupon-details-amount-title">Amount Details</h3>
              <hr className="coupon-details-divider" />
              <div className="coupon-details-amount-content">
                <div className="coupon-details-amount-item">
                  <span className="coupon-details-amount-label">Max Cash Back</span>
                  <span className="coupon-details-amount-value">₹ {coupon?.maxCashback}</span>
                </div>
                <div className="coupon-details-amount-item">
                  <span className="coupon-details-amount-label">Min Cash Back</span>
                  <span className="coupon-details-amount-value">₹ {coupon?.minCashBack}</span>
                </div>
                <div className="coupon-details-amount-item">
                  <span className="coupon-details-amount-label">Amount Type Details</span>
                  <span className="coupon-details-amount-value">{coupon?.amountType}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Other Details Section */}
        <div className="coupon-details-other-section">
          <div className="coupon-details-other-header">
            <img src={Details} className="coupon-details-other-icon" alt="details" />
            <h3 className="coupon-details-other-title">Other Details</h3>
          </div>
          <hr className="coupon-details-divider" />
          <div className="coupon-details-other-content">
            <div className="coupon-details-other-item">
              <span className="coupon-details-other-label">Applied to VM</span>
              <span className="coupon-details-other-value">{coupon?.appliedVm || "—"}</span>
            </div>
            <div className="coupon-details-other-item">
              <span className="coupon-details-other-label">Free Gift Details</span>
              <span className="coupon-details-other-value">{coupon?.freeGift || "—"}</span>
            </div>
          </div>
        </div>

        {/* T&C Section */}
        <div className="coupon-details-tnc-section">
          <p className="coupon-details-tnc-text">
            <strong>*T&C Apply:</strong> This coupon can be used 1 time by a user in 7 days.
            Offer valid till 15th March 2025. The coupon will be applicable on all products.
            This offer cannot be combined with other offers. Other standard terms and conditions apply.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CouponDetails;